const HEADER = "X-Apps-Client";
let appsClientId = null;
/** Call once at host startup (each JS context: background, page, compose, PWA). */
export function setAppsClientId(id) {
    appsClientId = id;
}
export function getAppsClientId() {
    return appsClientId;
}
/** Header map fragment for fetch(); empty when unset. */
export function appsClientHeaders() {
    return appsClientId ? { [HEADER]: appsClientId } : {};
}
